import moment from 'moment';

export default time => {
  return time && moment(time).format('l LT');
};
